import { ISiteWalkMedia } from '@api/models';
import { createFloorPlansGui } from '@api/services/sitewalk-gui.service';
import FileUploadPreview from '@components/FileUploadPreview/FileUploadPreview';
import DragAndDropFileUpload from '@components/FormFields/DragAndDropFileUpload';
import { Button, CircularProgress, HelpText } from '@hyperflake/react-ui-library';
import { ErrorMessage, Form, Formik } from 'formik';
import { getMediaType } from 'modules/site-walk-gui/helper/floor-plan-gui.utils';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

interface CreateFloorPlanGuiProps {
    onSave: () => void;
}

const AddDocumentSchema = Yup.object({
    // file: Yup.array().min(1, 'Please select at least one file').required('Please select at least one file'),
    // name: Yup.string().trim().required('This field is required'),
});

const CreateFloorPlanGui = ({ onSave }: CreateFloorPlanGuiProps) => {
    const { clientId, projectId } = useParams();
    const initialValues = {
        file: null as File | null, // single file, not array
    };

    const handleSubmit = async (values: { file: File | null }) => {
        try {
            if (!values.file) return;

            const formData = new FormData();
            formData.append('file', values.file);
            formData.append('mediaType', getMediaType(values.file));

            const updatedFloorPlanMedia = await createFloorPlansGui(clientId, projectId, formData);

            onSave?.();

            toast.success('Floor Plan Created successfully.');
        } catch (err: any) {
            if (err?.message === 'canceled' || err?.code === 'ERR_CANCELED') return;
            toast.error(err?.data?.message || 'Some error occurred, please try again.');
        }
    };
    return (
        <div className="">
            {/* <h4>Upload File</h4> */}

            <div className="mt-2">
                <Formik
                    initialValues={initialValues}
                    validationSchema={AddDocumentSchema}
                    enableReinitialize
                    onSubmit={handleSubmit}
                >
                    {({ values, setFieldValue, isSubmitting, errors }) => {
                        // console.log('errors', errors);

                        return (
                            <Form id="uploadFileForm">
                                <div className="">
                                    <DragAndDropFileUpload
                                        text="Browse JPG/PNG/MP4"
                                        accept={{
                                            'image/*': ['.jpeg', '.jpg', '.png'],
                                            'video/*': ['.mp4'],
                                        }}
                                        onChange={(files) => setFieldValue('file', files[0])}
                                    />
                                </div>
                                <HelpText variant="error">
                                    <ErrorMessage name="file" />
                                </HelpText>

                                <div className="mt-4">
                                    {values.file && (
                                        <div>
                                            <FileUploadPreview
                                                name={values.file.name}
                                                size={values.file.size}
                                                onCancel={() => setFieldValue('file', null)}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="mt-auto">
                                    <Button
                                        type="submit"
                                        form="uploadFileForm"
                                        disabled={values.file === null || isSubmitting}
                                    >
                                        {isSubmitting ? <CircularProgress size={20} color={'inherit'} /> : 'Upload'}
                                    </Button>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

export default CreateFloorPlanGui;
